import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll } from 'services/WService';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalSaleForce(props) {
  const saleForce = props.model;

  const [dataChanging, setDataChanging] = useState(saleForce);

  const [zones, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listBureaus() {
    let response = await wsGetAll('base/bureau');
    if (response.success) setBureaus(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    if (saleForce.open) {
      listZones();
      listBureaus();
    }
  }, [saleForce.open]);

  return (
    <Modal
      title="Fuerza de venta"
      model={saleForce}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="base/sale-force"
      state
    >
      {zones.length > 0 ? (
        <Autocomplete
          options={zones}
          getOptionLabel={(option) => option.description}
          defaultValue={
            !!saleForce ? zones.find((item) => item.id == saleForce.base_zone_id) : undefined
          }
          renderInput={(params) => <TextField {...params} label="Zona" margin="normal" required />}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_zone_id', item.id);
            }
            handleChange('base_zone_id', null);
          }}
        />
      ) : undefined}

      {bureaus.length > 0 ? (
        <Autocomplete
          options={bureaus}
          getOptionLabel={(option) => option.description}
          defaultValue={
            !!saleForce ? bureaus.find((item) => item.id == saleForce.base_bureau_id) : undefined
          }
          renderInput={(params) => <TextField {...params} label="Mesa" margin="normal" required />}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_bureau_id', item.id);
            }
            handleChange('base_bureau_id', null);
          }}
        />
      ) : undefined}
    </Modal>
  );
}
